// Журнал изменений: /api/changes. Типы зеркалят app/domain/schemas/changelog.py.

import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/api/client'

export type ActorKind = 'web' | 'mcp' | 'ai' | 'sync' | 'import' | 'system'

export type Change = {
  id: string
  at: string
  actor_kind: ActorKind
  actor_label: string
  entity: string
  entity_id: string
  op: 'create' | 'update' | 'delete' | 'undo'
  before: Record<string, unknown> | null
  after: Record<string, unknown> | null
  undone_by: string | null
  summary_ru: string
  can_undo: boolean
}

export type ChangePage = { items: Change[]; next_cursor: string | null }

export const changeKeys = {
  all: ['changes'] as const,
  list: (source: string) => ['changes', source] as const,
}

export const changesApi = {
  list: (source: string, cursor: string | null) =>
    api.get<ChangePage>('/changes', { query: { source: source || null, cursor, limit: 30 } }),
  undo: (id: string) => api.post<Change>(`/changes/${id}/undo`),
}

export function useChanges(source: string) {
  return useInfiniteQuery({
    queryKey: changeKeys.list(source),
    queryFn: ({ pageParam }) => changesApi.list(source, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.next_cursor,
  })
}

/** Откат меняет данные любого раздела, поэтому после него сбрасываем весь кэш запросов. */
export function useUndoChange() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: changesApi.undo,
    onSuccess: () => client.invalidateQueries(),
  })
}
